const chunkArray = (str, chunkSize) => {
  const temp = [];
  const strWithoutStringType = [...str].filter((char) => /[0-9]/.test(char)).join('');

  for (let i = 0; i < str.length; i += chunkSize) {
    temp.push(strWithoutStringType.substr(i, chunkSize));
  }
  return temp.filter((i) => i);
};

const normalizeKeyInput = (nativeEvent, chunkSize, delimiter, chunkCount) => {
  const { target, data } = nativeEvent; //data - последний введенный символ. data === null при вставке, удалении
  const { value } = target;
  const len = value.length;
  const maxLength = chunkCount * chunkSize + chunkCount;

  const charsChunkBeforeLastChar = value.substr(-chunkSize - 1, chunkSize);
  const isLastCharDelimiter = value[len - 2] === delimiter;
  const isDataNotNumber = !/[0-9]/.test(data) && data !== null;

  if (isDataNotNumber && isLastCharDelimiter && target.selectionStart === len) return null;

  const re = new RegExp(`\\d{${chunkSize}}`);
  if (data === delimiter
    && target.selectionEnd === len
    && target.selectionEnd !== maxLength
    && re.test(charsChunkBeforeLastChar)
  ) return {
    normalizedValue: value,
    cursorPosition: target.selectionEnd,
  };

  if (len >= maxLength && nativeEvent.inputType !== 'deleteContentBackward') return null;

  const chunkedString = chunkArray(value.split(delimiter).join(''), chunkSize);
  let normalizedValue = chunkedString.slice(0, chunkCount).join(delimiter);

  const delimiterCount = normalizedValue.split(delimiter).length;
  let cursorPosition = target.selectionStart;

  if ((nativeEvent.inputType === 'deleteContentBackward' || nativeEvent.inputType === 'deleteContentForward')
    || cursorPosition < len - 1) {
    cursorPosition = target.selectionStart
  } else {
    cursorPosition = target.selectionStart + delimiterCount;
  }

  if (isDataNotNumber) return {
    normalizedValue,
    cursorPosition: target.selectionStart - 1,
  };

  return {
    normalizedValue,
    cursorPosition,
  }
};

export const normalizeVersionNumberInput = (value) => {
  if (value.length >= 10) return null;
  const lastChar = value.substr(-1);
  const valueWithoutLastChar = value.substr(0, value.length - 1) || '';

  const re = new RegExp(`\\d+\\.\\d+\\.\\d+[^\\d]`, 'g');

  if (re.exec(value)) return valueWithoutLastChar.trim();

  if (lastChar === '.' && valueWithoutLastChar.substr(-1) === '.') return valueWithoutLastChar.trim();
  return value.trim();
};

export const normalizeServerBaseLicenceKeyInput = (value) =>
  normalizeKeyInput(value, 4, '-', 6);

export const normalizeDeviceKeyInput = (value) =>
  normalizeKeyInput(value, 4, '-', 4);

export const normalizeServerUnlimitedLicenceKeyInput = (value) =>
  normalizeKeyInput(value, 4, '-', 4);

export const normalizeViewerLicenceKeyInput = (value) =>
  normalizeKeyInput(value, 4, '-', 4);

export const normalizeViewerProLiteLicenceKeyInput = (value) =>
  normalizeKeyInput(value, 4, '-', 5);



// WEBPACK FOOTER //
// ./src/common/normalizeKeyInput.js